import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import { t } from '../../i18n/translate.js';
import Button from '../../components/Button/Button.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import { useGlobalLogout } from '../../services/logout/useGlobalLogout.js';
import styles from './SessionExpireModal.module.scss.js';

var SessionExpireModal = function (_a) {
    var visible = _a.visible, keepAlive = _a.keepAlive, remaining = _a.remaining;
    var globalLogout = useGlobalLogout().globalLogout;
    return (React.createElement("div", { "data-testid": "idler" },
        React.createElement(Modal, { overlayClassName: styles.overlayWarning, className: styles.modalWarning, isOpen: visible, shouldCloseOnOverlayClick: true, onRequestClose: remaining > 0 ? keepAlive : globalLogout },
            React.createElement("div", { className: styles.contentWrapper, "data-testid": "session-dialog" }, remaining > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("h1", { className: classNames('title', styles.title) }, t('MPLIB_SESSION_EXPIRING')),
                React.createElement("p", { className: styles.text }, t('MPLIB_SESSION_EXPIRING_CONTDOWN', { remaining: remaining })),
                React.createElement("div", { className: styles.buttonBar },
                    React.createElement(Button, { dataTestId: "keep-alive", text: t('MPLIB_SESSION_EXPIRING_STILL_HERE'), onClick: keepAlive, className: styles.optionButton, flat: true })))) : (React.createElement(React.Fragment, null,
                React.createElement("h1", { className: classNames('title', styles.title) }, t('MPLIB_SESSION_EXPIRED')),
                React.createElement("p", { className: styles.text }, t('MPLIB_SESSION_EXPIRED_REASON')),
                React.createElement("div", { className: styles.buttonBar },
                    React.createElement(Button, { dataTestId: "close-view", text: t('MPLIB_CLOSE'), onClick: globalLogout, className: styles.optionButton, flat: true }))))))));
};

export { SessionExpireModal };
